import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const CircleCheck: React.FC<SvgProps> = ({ color, ...props }) => (
  <Svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <Path
      d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
      fill={color || '#FFF'}
    />
    <Path
      d="M10.5814 15.5796C10.3814 15.5796 10.1914 15.4996 10.0514 15.3596L7.22141 12.5296C6.93141 12.2396 6.93141 11.7596 7.22141 11.4696C7.51141 11.1796 7.99141 11.1796 8.28141 11.4696L10.5814 13.7696L15.7214 8.62961C16.0114 8.33961 16.4914 8.33961 16.7814 8.62961C17.0714 8.91961 17.0714 9.39961 16.7814 9.68961L11.1114 15.3596C10.9714 15.4996 10.7814 15.5796 10.5814 15.5796Z"
      fill={color || '#FFF'}
    />
  </Svg>
);

export default CircleCheck;
